import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, flow, makeObservable, observable } from "mobx";
import { SingleFile } from "../models/singleFile.js";
import { request } from "../utils/request.js";
import { locationRestAttachmentGet } from "../wp-api/attachment.get.js";
import { locationRestAttachmentsGet } from "../wp-api/attachments.get.js";
import { locationRestAttachmentsPost } from "../wp-api/attachments.post.js";
class AttachmentsStore {
    analyzeBusy = false;
    regenerateBusy = false;
    singleBusy = false;
    single;
    all = new Map();
    regenerated = [];
    analyzed = [];
    rootStore;
    get regenerateFailures() {
        return this.regeneratedObjects.filter(({ error })=>!!error?.length).length;
    }
    get regeneratedObjects() {
        return this.regenerated.map((id)=>this.all.get(id));
    }
    get analyzedObjects() {
        return this.analyzed.map((id)=>this.all.get(id));
    }
    constructor(rootStore){
        this.rootStore = rootStore;
        makeObservable(this);
    }
    analyze = flow(function*() {
        this.analyzeBusy = true;
        this.analyzed = [];
        let page = 0;
        try {
            while(++page){
                const result = yield request({
                    location: locationRestAttachmentsGet,
                    params: {
                        page,
                        posts_per_page: 40
                    }
                });
                if (result?.length) {
                    for (const row of result){
                        this.all.set(row.id, row);
                        this.analyzed.unshift(row.id);
                    }
                } else {
                    break;
                }
            }
        } catch (e) {
            console.log(e);
        } finally{
            this.analyzeBusy = false;
            this.rootStore.statsStore.fetch();
        }
    });
    fetchSingle = flow(function*(id, inDialog = true) {
        this.singleBusy = true;
        try {
            const result = yield request({
                location: locationRestAttachmentGet,
                params: {
                    id
                }
            });
            const obj = new SingleFile(result);
            if (inDialog) {
                this.single = obj;
            }
            return obj;
        } finally{
            this.singleBusy = false;
            this.rootStore.statsStore.fetch();
        }
    });
    regenerate = flow(function*(sizes, forceNewSchema, skipExisting, startPage = 0) {
        this.regenerateBusy = true;
        this.regenerated = [];
        const { chunkSize } = this.rootStore.optionStore.others;
        let page = startPage;
        try {
            while(++page){
                const result = yield request({
                    location: locationRestAttachmentsPost,
                    params: {
                        page,
                        posts_per_page: chunkSize
                    },
                    request: {
                        forceNewSchema,
                        sizes,
                        skipExisting
                    }
                });
                if (result?.length) {
                    for (const row of result){
                        this.all.set(row.id, row);
                        this.regenerated.unshift(row.id);
                    }
                } else {
                    break;
                }
            }
        } catch (e) {
            console.log(e);
            // Catch 503er errors when the server is overloaded
            const eXhr = e;
            if (eXhr.status === 503) {
                // Do not rely on Retry-After, simply wait 10 seconds and try again
                yield new Promise((resolve)=>setTimeout(resolve, 10000));
                return yield this.regenerate(sizes, forceNewSchema, skipExisting, page - 1);
            }
        } finally{
            this.regenerateBusy = false;
            this.rootStore.statsStore.fetch();
        }
    });
    clear = flow(function*() {
        if (process.env.PLUGIN_CTX === "pro") {
        /* Silence is golden... Until you have PRO Version! */ } else {
            throw new Error("This feature is not available in the free version.");
        }
    });
}
_ts_decorate([
    observable
], AttachmentsStore.prototype, "analyzeBusy", void 0);
_ts_decorate([
    observable
], AttachmentsStore.prototype, "regenerateBusy", void 0);
_ts_decorate([
    observable
], AttachmentsStore.prototype, "singleBusy", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", typeof SingleFile === "undefined" ? Object : SingleFile)
], AttachmentsStore.prototype, "single", void 0);
_ts_decorate([
    observable
], AttachmentsStore.prototype, "all", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Array)
], AttachmentsStore.prototype, "regenerated", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Array)
], AttachmentsStore.prototype, "analyzed", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], AttachmentsStore.prototype, "regenerateFailures", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], AttachmentsStore.prototype, "regeneratedObjects", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], AttachmentsStore.prototype, "analyzedObjects", null);
export { AttachmentsStore };
